import { createContext } from 'react'

const GlobalLangCtx = createContext(null)

export default GlobalLangCtx;
